/*
 * @Description: 线索管理公共枚举数据字典
 * @Author: mdb
 * @Date: 2022-07-06 14:31:16
 * @LastEditTime: 2022-09-06 13:26:27
 * @LastEditors: mdb
 */

// 线索状态
export const clueStatusEnum = [
  { value: undefined, label: '全部' },
  { value: 3, label: '跟进中', color: '#EF8D3C', desc: '与客户正常沟通' },
  { value: 8, label: '已转化', color: '#3FAC46', desc: '已经转为潜在客户 ' },
  { value: 5, label: '无效线索', color: '#DF443B', desc: '信息错误，无法联系' },
  { value: 6, label: '未来线索', color: '#DF443B', desc: '客户真实，目前拒绝，未来有机会合作' }
]
// 客户状态
export const customerStatusEnum = [
  { label: '谈判', value: 10, disabled: false, desc: '一切协商、交涉、商量、磋商等' },
  { label: '已注册', value: 11, disabled: false, desc: '已在官网进行注册' },
  { label: '暂无法合作', value: 13, disabled: false, desc: '客户目前拒绝' }
]

export default { clueStatusEnum, customerStatusEnum }
